module.exports = __webpack_public_path__ + "static/media/flip.b7b32309.png";